import { useSearchParams } from 'react-router-dom'

export function useLinkCorrelationId() {
  const [searchParams] = useSearchParams()
  return searchParams.get('link_correlation_id')
}
